var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccesscontrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_390_1",
    "data-name": "Component 390 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15242",
    "data-name": "Group 15242",
    transform: "translate(-214 -4543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15241",
    "data-name": "Group 15241",
    transform: "translate(-0.752 54.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15240",
    "data-name": "Group 15240",
    transform: "translate(28.868 9.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_search_24dp_000000_FILL0_wght300_GRAD0_opsz24",
    d: "M150.165-762.823a4.568,4.568,0,0,1-3.35-1.393,4.568,4.568,0,0,1-1.394-3.35,4.567,4.567,0,0,1,1.394-3.35,4.567,4.567,0,0,1,3.35-1.394,4.567,4.567,0,0,1,3.35,1.394,4.567,4.567,0,0,1,1.394,3.35,4.568,4.568,0,0,1-1.394,3.35A4.568,4.568,0,0,1,150.165-762.823Zm0-2.033a2.61,2.61,0,0,0,1.914-.8,2.61,2.61,0,0,0,.8-1.914,2.61,2.61,0,0,0-.8-1.914,2.61,2.61,0,0,0-1.914-.8,2.61,2.61,0,0,0-1.914.8,2.61,2.61,0,0,0-.8,1.914,2.61,2.61,0,0,0,.8,1.914A2.61,2.61,0,0,0,150.165-764.856ZM140-754.56v-.933a3.421,3.421,0,0,1,.531-1.854,3.6,3.6,0,0,1,1.456-1.315,19.165,19.165,0,0,1,3.311-1.3,14.841,14.841,0,0,1,4-.618.915.915,0,0,1,.735.27.978.978,0,0,1,.3.722,1.024,1.024,0,0,1-.3.736,1.144,1.144,0,0,1-.735.354,14.684,14.684,0,0,0-3.8.634,17.492,17.492,0,0,0-2.562,1.014,1.627,1.627,0,0,0-.669.572,1.4,1.4,0,0,0-.239.784v.959h7.095a.983.983,0,0,1,.724.292.983.983,0,0,1,.292.724.982.982,0,0,1-.292.724.983.983,0,0,1-.724.292h-7.069a1.986,1.986,0,0,1-1.458-.6A1.986,1.986,0,0,1,140-754.56ZM150.165-767.566ZM149.738-754.534Z",
    transform: "translate(50.884 5256.531)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "shield_24dp_000000_FILL0_wght300_GRAD0_opsz24",
    d: "M185.036-840.672a1.249,1.249,0,0,1-.205-.017,1.124,1.124,0,0,1-.2-.05,6.575,6.575,0,0,1-3.38-2.679A7.45,7.45,0,0,1,180-847.569v-3.024a1.152,1.152,0,0,1,.22-.689,1.254,1.254,0,0,1,.569-.444l3.822-1.427a1.249,1.249,0,0,1,.425-.078,1.249,1.249,0,0,1,.425.078l3.822,1.427a1.254,1.254,0,0,1,.569.444,1.152,1.152,0,0,1,.22.689v3.024a7.45,7.45,0,0,1-1.256,4.151,6.575,6.575,0,0,1-3.38,2.679,1.124,1.124,0,0,1-.2.05A1.249,1.249,0,0,1,185.036-840.672Zm0-.988a5.465,5.465,0,0,0,2.887-2.216,6.378,6.378,0,0,0,1.142-3.693V-850.6a.2.2,0,0,0-.036-.116.213.213,0,0,0-.1-.078l-3.822-1.427a.189.189,0,0,0-.071-.013.189.189,0,0,0-.071.013l-3.822,1.427a.213.213,0,0,0-.1.078.2.2,0,0,0-.036.116v3.031a6.378,6.378,0,0,0,1.142,3.693A5.465,5.465,0,0,0,185.036-841.66ZM185.036-846.952Z",
    transform: "translate(50.927 5410.988)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7741",
    "data-name": "Rectangle 7741",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesscontrol);
export default __webpack_public_path__ + "static/media/accesscontrol.2b1f81b7b0970f595b003dbdaeb89826.svg";
export { ForwardRef as ReactComponent };